/* eslint-disable */
import 'whatwg-fetch'; // IE11 support
import Cookies from 'js-cookie';
import get from 'lodash/get';

// Set vars.
const $ = window.jQuery;
const stsharedNewsLetter = window.stsharedNewsLetter || {};

/**
 * Console Log on Debug
 */
stsharedNewsLetter.log = ( title = '', data = '' ) => {
	const isDebug = stsharedNewsLetter.isDebug;
	if ( isDebug ) {
		window.console.log( 'FVC NewsLetter: ' + title, data );
	}
};

/**
 * Get tracking ids accepted by the subscription service.
 */
stsharedNewsLetter.getTrackingIds = () => ({
  pageStateId: get(window, '__stsharedTrackingObj.pageStateId') || '',
  userSessionId: get(window, '__stsharedTrackingObj.userSessionId') || '',
});

/**
 * Gets existing user if email exists in API and sign them up if they aren't a user.
 *
 * @param {string} email   email address.
 * @param {string} ages    Children Ages.
 * @param {string} [context=false] Context.
 * @param {string} [widget=false] The location of the widget used for signup.
 *
 * @return {object} subscriber object or null if the user doesn't exist
 */
stsharedNewsLetter.emailLookUp = ( email, ages = [], context = false, widget = false, e = false ) => {
  fetch(stsharedNewsLetter.restURL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			email,
			action: 'emailLookUp',
			nocache: new Date().getTime(),
			...stsharedNewsLetter.getTrackingIds(),
		}),
	})
  .then(res => res.json())
  .then( ( responseData ) => {
		if ( responseData &&
			Array.isArray( responseData ) &&
			responseData[0] &&
			responseData[0].status &&
			'valid' === responseData[0].status ) {

			stsharedNewsLetter.setCurrentUser( responseData[0], widget);
			if ( false !== ages ) {
				stsharedNewsLetter.setChildren( ages.join() );
			}
			if ( 'modal' === context ) {
				stsharedNewsLetter.thanks( e );
			}
			if ( 'footer' === context ){
				stsharedNewsLetter.success( e );
			}
			stsharedNewsLetter.hideForm();
		} else {
			stsharedNewsLetter.log( 'register fail.', responseData );
			// stsharedNewsLetter.closeModal();

			if ( 'footer' === context ){
				stsharedNewsLetter.failure( e );
			}

			stsharedNewsLetter.thanks( e );
		}

		// Always submit search even when fail.
		if ( 'search' === context ) {
			stsharedNewsLetter.submitDestinationSearch();
		}
		stsharedNewsLetter.log( 'emailLookUp done', responseData );
	} ).catch( ( errorThrown ) => {
		if ( 'search' === context ) {
			stsharedNewsLetter.submitDestinationSearch();
		}
		if ( 'footer' === context ) {
			stsharedNewsLetter.failure();
		}
		stsharedNewsLetter.log( 'emailLookUp fail', errorThrown );
	} );
};

/**
 * Set user by tracking number
 * ToDo: Need to determine when/where the newsletter-management.js function
 * of the same name is called. This method is currently called on the Newsletters
 * page of the ST website. As well, this is fired on page load only if there is a cookie
 * set. NOT upon login.
 *
 * @param {string} trackingCode user tracking code from cookie
 *
 * @return {void}
 */
stsharedNewsLetter.setUserByTracking = ( trackingCode ) => {
	fetch(stsharedNewsLetter.restURL, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			action: 'getUserByTracking',
			tracking: trackingCode,
			nocache: new Date().getTime(),
			...stsharedNewsLetter.getTrackingIds(),
		}),
	})
  .then(res => res.json())
  .then( ( responseData ) => {
		if ( responseData &&
			responseData.status &&
			'valid' === responseData.status ) {
			stsharedNewsLetter.setCurrentUser( responseData );
			stsharedNewsLetter.hideForm();
		}

		stsharedNewsLetter.log( 'setUserByTracking done', responseData );
	} ).catch( ( errorThrown ) => {
		stsharedNewsLetter.log( 'setUserByTracking fail', errorThrown );
	} );
};

/**
 * Set user by tracking number
 *
 * @param {string} ages Ages.
 *
 * @return {void}
 */
stsharedNewsLetter.setChildren = ( ages ) => {
	const trackingCode = Cookies.get( 'u' );

	if ( trackingCode && ages ) {
		stsharedNewsLetter.log( 'setChildren trackingCode', trackingCode );

    fetch(stsharedNewsLetter.restURL, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				action: 'setChildren',
				tracking: trackingCode,
				children: ages,
				nocache: new Date().getTime(),
				...stsharedNewsLetter.getTrackingIds(),
			}),
		})
    .then(res => res.json())
    .then( ( responseData ) => {
			stsharedNewsLetter.log( 'setChildren done', responseData );
		} ).catch( ( errorThrown ) => {
			stsharedNewsLetter.log( 'setChildren fail', errorThrown );
		} );
	}
};

/**
 * Set current user Data
 *
 * @param {object} userData User's data from the API.
 * @param {string} [context=false] Context.
 * @param {string} [widget=false] The location of the widget used for signup.
 *
 * @return {void}
 */
stsharedNewsLetter.setCurrentUser = ( userData, widget = false ) => {
	if ( 0 <= window.location.host.indexOf( 'familyvacationcritic.com' ) ) {
		//set cookie to root
		Cookies.set( 'u', userData.trackingCode, {expires: 7 , domain: 'familyvacationcritic.com' } );
	} else {
		Cookies.set( 'u', userData.trackingCode, {expires: 7} );
	}

	Cookies.set( 'loggedIn', true, {expires: 7} );
	stsharedNewsLetter.hideForm();

	// Tracking.
	if ( 1 === userData.isNewUser ) {
		window.EventBus.emit( 'newsletter::subscribe', {
			events: 'event4',
			widget: widget,
		} );
	}

	// Comparison page email input
	const emailInput = document.querySelector( '.main .js-newsletter-form .st-newsletter-input' );

	// Form inputs that should be prepopulated
	if ( emailInput ){
		emailInput.value = userData.emailAddress;
		emailInput.classList.add( 'is-subscribed' );
	}

	// Deals page email input
	const dealsInput = document.querySelector( '#deals-search .js-newsletter-form .st-newsletter-input' );

	// Form inputs that should be prepopulated
	if ( dealsInput ){
		dealsInput.value = userData.emailAddress;
		dealsInput.classList.add( 'is-subscribed' );
	}
};

/**
 * Is user LoggedIn
 *
 * @return {void}
 */
stsharedNewsLetter.isUserLoggedIn = () => {
	const trackingCode = Cookies.get( 'u' );

	return trackingCode ? true : false;
};

/**
 * Hide Subscribe Forms.
 *
 * @return {void}
 */
stsharedNewsLetter.hideForm = () => {
	$( '.social-links__item--subscribe' ).hide();
	$( '.site-footer__subscribe' ).css('opacity','0').css('visibility','hidden');
	$( '.vacation-search__subscribe-label' ).css('opacity','0').css('visibility','hidden');
	$( '#js-vacation-search-email-container' ).hide();
};

/**
 * Close Subscribe Modal.
 *
 * @return {void}
 */
stsharedNewsLetter.closeModal = () => {
	$( '#subscribe-modal' ).attr( 'aria-hidden', 'true' ).removeClass( 'gate' );
	$( 'body' ).removeClass( 'modal-is-open' );
	$( '.a11y-hide-if-modal-open' ).attr( 'aria-hidden', '' );
	$( '#js-subscribe-link' ).focus();
};

/**
 * Open Subscribe Modal.
 *
 * @return {void}
 */
stsharedNewsLetter.openModal = () => {
	$( '#subscribe-modal' ).attr( 'aria-hidden', 'false' ).addClass( 'gate' );
	$( 'body' ).addClass( 'modal-is-open' );
	$( '.a11y-hide-if-modal-open' ).attr( 'aria-hidden', 'false' );
	$( '#subscribe-modal' ).focus();
};

/**
 * Set Subscribe Modal to Confirm state.
 *
 * @return {void}
 */
stsharedNewsLetter.thanks = ( e = false ) => {
	$( '#subscribe-modal' ).addClass( 'thanks' );
	// close in 5s
	setTimeout( stsharedNewsLetter.closeModal, 5000 );
};

/**
 * Set Subscribe text to display successful state
 *
 * @return {void}
 */
stsharedNewsLetter.success = ( e = false  ) => {
	if ( typeof st_subscription != 'undefined' && e ) {
		$( e.currentTarget ).closest('.js-st-newsletter-subscription-widget').text( st_subscription.response.success );
	}
	else if( $('.site-footer__subscribe').length ){
		// For FVC show an alert message if signed up
		alert( 'Thank you for subscribing, you will receive your first newsletter shortly.' );
	}
};

/**
 * Set Subscribe text to display unsuccessful state.
 *
 * @return {void}
 */
stsharedNewsLetter.failure = ( e = false ) => {
	if ( typeof st_subscription != 'undefined' && e ) {
		$( e.currentTarget ).closest('.js-st-newsletter-subscription-widget').text( st_subscription.response.failure );
	}
};
// open subscribe modal on load if no cookie 'u' and if no visit in 24h and if not clicking through on fvc nl

// check if modal should open

/**
 * Submit Destination Form!
 *
 * @return {void}
 */
stsharedNewsLetter.submitDestinationSearch = function() {
	$( '.vacation-search__form' ).submit();
};

/**
 * Get URL param
 *
 * @param variable
 * @returns {void}
 */
stsharedNewsLetter.get_url_param = function( variable ) {
	const query = window.location.search.substring( 1 );

	if ( !query ) {
		return;
	}

	const vars = query.split( '&' );

	if ( vars && vars.length ) {
		for ( let i = 0; i < vars.length; i++ ) {
			const pair = vars[i].split( '=' );

			if ( pair && ( pair[0] === variable ) ) {
				return decodeURIComponent( pair[1] );
			}
		}
	}

	return false;
};

/**
 * Validates email address
 *
 * @param {string} email email string
 *
 * @return {bool} whether a string is a valid email
 */
stsharedNewsLetter.isEmailValid = ( email ) => {
	const regex = new RegExp( /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/ ); // eslint-disable-line no-useless-escape

	return regex.test( email );
};

/**
 * Cookie for popup
 * @returns {void}
 */
stsharedNewsLetter.getPopupCookie = () => Cookies.get( 'stshared-entry' );

/**
 * Cookie for popup
 * @returns {void}
 */
stsharedNewsLetter.setPopupCookie = () => {
	const cookie_domain = "." + location.hostname.split('.').reverse()[1] + "." + location.hostname.split('.').reverse()[0];
	Cookies.set( 'stshared-entry', true, { expires: 1, domain: cookie_domain } );
};

/**
 * Compute if popup will show
 * @returns {void}
 */
stsharedNewsLetter.willShowPopUp = () => {
	const userParam = stsharedNewsLetter.get_url_param( 'u' );
	const nl = stsharedNewsLetter.isUserLoggedIn();
	const expired = stsharedNewsLetter.getPopupCookie();

	if ( !userParam && !nl && !expired ) {
		return true;
	}

	return false;
};

/**
 * Newsletter Management
 *
 * @return {void}
 */
const init = () => {
	const subscribeModal = $( '#subscribe-modal' );
	const newsletterApp = $( '#newsletter-app' );
	const url = stsharedNewsLetter.get_url_param( 'u' );
	const showPopUp = stsharedNewsLetter.willShowPopUp();
	let trackingCode = Cookies.get( 'u' );

	if ( ! window.stsharedNewsLetter ) {
		return;
	}

	if ( showPopUp && subscribeModal.length ) {
		window.stsharedNewsLetter.setPopupCookie();
		if ( 0 <= window.location.host.indexOf( 'familyvacationcritic' ) ) {
			setTimeout( window.stsharedNewsLetter.openModal, 1 );
		} else {
			setTimeout( window.stsharedNewsLetter.openModal, 3000 );	
		}
	}

	if ( url ) {
		trackingCode = url;
	}

	if ( trackingCode && newsletterApp.length ) {
		window.stsharedNewsLetter.setUserByTracking( trackingCode );
	}
};

stsharedNewsLetter.setUpSubscribeModal = () => {
	// Hide email form if logged-in.
	if ( stsharedNewsLetter.isUserLoggedIn() ) {
		window.stsharedNewsLetter.hideForm();
		return;
	}

	// Submit subscribe modal.
	$( document ).on( 'submit', '.subscribe-form', function(e) {
		e.preventDefault();
		if ( stsharedNewsLetter.isUserLoggedIn() ) {
			return false;
		}

		const email = $( this ).find( '#subscribe-email-address' ).val();
		const ages = [];
		$( document ).find( '.custom-select select[name="custom[]"]' ).each( function() {
			const age = $( this ).val();
			if ( 'Age' !== age && 'age' !== age ) {
				ages.push( $( this ).val() );
			}
		} );

		// Set user.
		window.stsharedNewsLetter.emailLookUp( email, ages, 'modal', 'modal', e );
	} );
}

stsharedNewsLetter.setUpSubscribeForm = () => {
	// Hide email form if logged-in.
	if ( stsharedNewsLetter.isUserLoggedIn() ) {
		window.stsharedNewsLetter.hideForm();
		return;
	}

	// Newsletter Subscribe form.
	$( document ).on( 'click', '.newsletter__submit', function( e ) {
		e.preventDefault();
		let input = $( this ).prev();
		let email = input.val();

		if ( '' === email ) {
			return false;
		}

		let widget = "unknown"
        const classNames = input[0].className.split( ' ' );
        classNames.every( item => {
            if ( item != "st-newsletter-input" && item.includes( "-newsletter-input" ) ) {
                widget = item.split( '-' )[0];
				return false;
            }
			return true;
        });

		window.stsharedNewsLetter.emailLookUp( email, false, 'footer', widget, e );
	} );
}

stsharedNewsLetter.setUpSearchFormSubscribe = () => {
	// Hide email form if logged-in.
	if ( stsharedNewsLetter.isUserLoggedIn() ) {
		window.stsharedNewsLetter.hideForm();
		return;
	}

	// On Search Form With Email Field.
	$( document ).on( 'click', '#vacation-search-vacation', function( e ) {
		var emailField = $('#vacation-search-email');
		var email = emailField.val();

		if ( email ) {
			e.preventDefault();

			if ( stsharedNewsLetter.isEmailValid( email ) ) {
				window.stsharedNewsLetter.emailLookUp(email, false, 'search', 'search', e );
			} else {
				window.alert( 'Please enter a valid email address.' );
			}

			return false;
		}
	} );

};

export default {init};
